import type { ReactNode } from 'react'

/**
 * Het NWO-merkblok: tegel + woordmerk, decoratief boven elke pagina van het product (R-157).
 *
 * Gedeeld tussen de configurator-balk (`apps/configurator/src/app/Balk.tsx`) en de productbalk
 * van de runtime-pod (`apps/runtime/pagina/Productbalk.tsx`): één component, één stijl, in
 * plaats van twee keer dezelfde drie regels markup.
 *
 * **Decoratie, geen titel.** `aria-hidden`: de echte paginatitel is elders een eigen heading, en
 * dit blok mag die heading-query niet dubbelzinnig maken (ontwerp 10.4).
 *
 * **Niet gemonteerd in `Invulformulier`.** Dat component draait ook binnen de configurator zijn
 * `Voorbeeld`-paneel, dat zelf al een merkblok in `Balk.tsx` toont; een tweede tegel daarbinnen
 * zou dubbel op het scherm staan. Elke aanroeper monteert dit component dus zelf, op zijn eigen
 * paginaniveau.
 */
export function BrandBlock(): ReactNode {
  return (
    <div className="ef-merkblok" aria-hidden="true">
      <span className="ef-merkblok__tegel">NWO</span>
      <span className="ef-merkblok__woordmerk">Grantify e-formulier</span>
    </div>
  )
}
